import { render, staticRenderFns } from "./order-own-shipping.vue?vue&type=template&id=665f94b0&"
import script from "./order-own-shipping.vue?vue&type=script&lang=js&"
export * from "./order-own-shipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports